import { useEffect, useState } from 'react';
import { Box } from '@mui/material';
import dayjs from 'dayjs';

import { Heading, iconBtnPosition, IconButton, Table } from '../../../../../packages';
import { ProfileInfo } from '../../../../../packages/ui/templates/profile-info';

import { useStyles } from './ProfileAssignmentTableCard.styles';
import {
  getProfileElementAssignmentChatBotListQuery,
  getProfileElementAssignmentEvaluationListQuery,
  mapChatBotResponseToTableObject,
  tableColumns,
} from './ProfileElementAssignmen.constants';
import {
  getElkProfileElementAssignmentChatBotList,
  getElkProfileElementAssignmentEvaluationList,
} from '../../../../../services/profile/profile.service';

const ProfileAssignmentTableCard = ({ profile, disableExport = false }) => {
  const classes = useStyles();
  const [assignmentList, setAssignmentList] = useState([]);
  const [tableParams, setTableParams] = useState({
    search: { searchKey: '', filter: null },
    pagination: { currentPage: 1, rowsPerPage: 10 },
    sorter: { direction: 'asc', column: '' },
  });
  const [listTotalCount, setListTotalCount] = useState(0);
  const [isLoading, setIsLoading] = useState(false);

  const getQueryParams = () => {
    const queryParams = {
      size: tableParams.pagination.rowsPerPage - 5,
      from: tableParams.pagination.currentPage - 1,
      profileKey: profile.profileElementInfo.key,
      searchKey: tableParams.search.searchKey,
    };
    return queryParams;
  };
  const fetchProfileElementAssignmentList = async () => {
    setIsLoading(true);
    let combineList;
    const chatBotList = await getElkProfileElementAssignmentChatBotList(
      getProfileElementAssignmentChatBotListQuery(getQueryParams()),
    );
    const evaluationList = await getElkProfileElementAssignmentEvaluationList(
      getProfileElementAssignmentEvaluationListQuery(getQueryParams()),
    );
    combineList = [
      ...mapChatBotResponseToTableObject(evaluationList.data),
      ...mapChatBotResponseToTableObject(chatBotList.data),
    ];
    const listCount =
      Number(chatBotList.data.hits.total.value) + Number(evaluationList.data.hits.total.value);
    setListTotalCount(listCount);
    setIsLoading(false);
    return combineList;
  };

  const renderColumns = tableColumns.map(column => {
    if (column.id === 'member') {
      return {
        ...column,
        renderCell: ({ firstName, lastName, fullName, profileImage, memberId }) => (
          <ProfileInfo
            type="member"
            photo={profileImage}
            nickName={fullName}
            fullName={`${firstName} ${lastName}`}
            memberId={memberId}
          />
        ),
      };
    }
    if (column.id === 'assignMethod') {
      return {
        ...column,
        renderCell: ({ type }) => <span>{type || '-'}</span>,
      };
    }
    if (column.id === 'previousValue') {
      return {
        ...column,
        renderCell: ({ previous, current }) => <span>{previous || current || '-'}</span>,
      };
    }
    if (column.id === 'currentValue') {
      return {
        ...column,
        renderCell: ({ current, previous }) => <span>{current || previous || '-'}</span>,
      };
    }
    if (column.id === 'date') {
      return {
        ...column,
        renderCell: date => dayjs(date).format('MM/DD/YYYY'),
      };
    }
    return column;
  });
  useEffect(() => {
    void (async () => {
      const list = await fetchProfileElementAssignmentList();

      const formattedList = list.map(item => ({
        ...item,
        previousValue: { previous: item.previousValue.previous, current: item.currentValue.current },
        currentValue: { previous: item.previousValue.previous, current: item.currentValue.current },
      }));

      setAssignmentList(formattedList);
    })();
  }, [profile, tableParams]);

  return (
    <Box className={classes.card}>
      <Box className={classes.head}>
        <Heading className={classes.title}>Profile Element Assignment</Heading>
        <IconButton
          icon="export"
          iconPosition={iconBtnPosition.RIGHT}
          className={classes.exportBtn}
          disabled={disableExport}
        >
          Export
        </IconButton>
      </Box>
      <Box>
        <Table
          searchProps={{
            placeholder: 'Search',
          }}
          gridProps={{
            columns: renderColumns,
            data: assignmentList,
            isLoading,
          }}
          paginationProps={{
            currentRows: tableParams.pagination.currentPage,
            totalCount: listTotalCount,
            showRowsPerPage: false,
          }}
          value={tableParams}
          onChange={newValues => {
            setTableParams(newValues);
          }}
          className={classes.table}
        />
      </Box>
    </Box>
  );
};

export { ProfileAssignmentTableCard };
